// extracted by mini-css-extract-plugin
export default {"loader_ontainer":"Loading_loader_ontainer__1OrKf","loader":"Loading_loader__Q2JbH"};